'use client';

import { useEffect, useState } from 'react';
import useCookie, { cookieOptions } from 'react-use-cookie';
import cx from 'classnames';

import { Link } from '@/components/Default/Link';

const Cookie = () => {
    const [state, setState] = useState<string|null>(null);
    const [consent, setConsent] = useCookie('_cookieConsent', '');

    const consentIsHidden = state === null || (! Number.isNaN(parseInt(state)) || state === 'false');

    const cookieOptions: cookieOptions = {
        days: 365
    };

    useEffect(
        () => {
            setState(consent);
        },
        [consent]
    );

    const handleOnDenyCookieConsent = () => {
        setConsent('false', {
            ...cookieOptions,
            days: 7
        });
    };

    const handleOnAcceptCookieConsent = () => {
        const value = Date.now().toString();

        setConsent(value, cookieOptions);
    };

    return (
        <div className={cx('block fixed px-1 sm:px-4 inset-x-0 bottom-1 sm:bottom-4 z-[2147483001]', {
            'hidden': consentIsHidden
        })}>
            <div className='sm:inset-x-0 bottom-0 sm:bottom-10 rounded-md sm:rounded-xl sm:border border-neutral-900 bg-black shadow-2xl w-full max-w-screen-md mx-auto overflow-hidden'>
                <div className='relative overflow-x-hidden overflow-y-auto py-4 sm:pb-0 sm:pt-8 px-8 text-white max-h-[100vh]'>
                    <div className='text-2xl pt-6 pb-4'>
                        <span className='text-3xl font-bold'>🍪 Cookies</span>
                    </div>
                    <div className='pb-4 space-y-2'>
                        <div className='text-base sm:text-lg'>
                            Deze site maakt gebruik van technologieën voor het volgen van websites van derden om onze services aan te bieden en voortdurend te verbeteren. Ik ga akkoord en kan mijn toestemming op elk moment intrekken of wijzigen met ingang voor de toekomst.
                        </div>
                        <Link href='/privacy-beleid' className='text-base sm:text-lg'>
                            Privacy statement
                        </Link>
                    </div>
                </div>
                <div className='w-full flex justify-center items-center border-t border-solid border-neutral-900'>
                    <button className='border-r border-neutral-900 flex-1 px-4 py-3 text-gray-200 hover:bg-neutral-900 duration-150' onClick={handleOnDenyCookieConsent}>
                        Nee bedankt!
                    </button>
                    <button className='flex-1 px-4 py-3 text-gray-200 hover:text-white hover:bg-neutral-900 duration-150' onClick={handleOnAcceptCookieConsent}>
                        Accepteren
                    </button>
                </div>
            </div>
        </div>
    );
};

export { Cookie };